import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import router from './router';
import request from './api/request';
import i18n from './i18n';
import './styles/index.less';

Vue.use(ElementUI, { locale });
Vue.use(i18n);
Vue.config.productionTip = false;
Vue.prototype.$axios = request;

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js